import dayjs from 'dayjs';

import posts from './looseleafs';

/*
 * Facts about this website and the open source it comes with.
 *
 * This repo is private, so counts that only mean something for a public repo
 * (stars, forks, watchers, open issues) are gone, along with their links, which
 * 404'd for everyone but the owner. The starred repos below are public, so both
 * the numbers and the links work.
 *
 * LINES_OF_JS, BUILD_DATE, REPOS and REPO_STARS are injected by webpack at
 * build time, so none of them can go stale the way the hardcoded numbers did.
 */
const starRows = REPOS.map(({ name, slug }) => ({
  label: `Stars on ${name}`,
  value: String(REPO_STARS[slug]),
  link: `https://github.com/${slug}`,
}));

const data = [
  {
    label: 'Lines of Javascript powering this website',
    value: String(LINES_OF_JS),
  },
  {
    label: 'Looseleafs published',
    value: String(posts.length),
  },
  ...starRows,
  {
    label: 'Last built at',
    value: dayjs(BUILD_DATE).format('MMMM D, YYYY'),
  },
];

export default data;
